var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7775 4.81407C17.3697 4.39827 16.8855 4.06842 16.3526 3.84338C15.8197 3.61833 15.2485 3.5025 14.6716 3.5025C14.0947 3.5025 13.5235 3.61833 12.9906 3.84338C12.4577 4.06842 11.9735 4.39827 11.5656 4.81407L10.7193 5.67661L9.87294 4.81407C9.04919 3.97457 7.93194 3.50294 6.76699 3.50294C5.60203 3.50294 4.48479 3.97457 3.66104 4.81407C2.83729 5.65358 2.37451 6.79219 2.37451 7.97943C2.37451 9.16667 2.83729 10.3053 3.66104 11.1448L4.50739 12.0073L10.7193 18.338L16.9312 12.0073L17.7775 11.1448C18.1855 10.7292 18.5092 10.2357 18.73 9.69259C18.9508 9.14947 19.0645 8.56733 19.0645 7.97943C19.0645 7.39153 18.9508 6.80939 18.73 6.26627C18.5092 5.72314 18.1855 5.22968 17.7775 4.81407Z",
    fill: "#FF3239",
    stroke: "#FF3239",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.86a48a770113f6bced578b5f66beb570.svg";
export { ForwardRef as ReactComponent };